import { api } from '../lib/api';

export interface CurrentPlan {
  planCode: 'A' | 'B' | 'C';
  planName: string;
  endAt: string;
  daysLeft: number;
}

export interface PlanListItem {
  planCode: 'A' | 'B' | 'C';
  planName: string;
  pricePerYearSek: number;
  description: string;
  includes: string[];
}

export interface UpgradeQuote {
  amountToPaySek: number;
  breakdown: {
    currentPlanCode: string;
    targetPlanCode: string;
    currentPriceSek: number;
    targetPriceSek: number;
    priceDiffSek: number;
    remainingRatio: number;
  };
}

export interface BillingReceipt {
  id: number;
  receiptNumber: string;
  planCode: string;
  grossAmountSek: number;
  vatAmountSek: number;
  netAmountSek: number;
  status: string;
  purchasedAt: string;
}

export interface BillingReceiptDetail extends BillingReceipt {
  businessName: string;
  orgNr: string | null;
  email: string | null;
  phone: string | null;
  website: string | null;
}

export interface PendingPurchase {
  id: number;
  currentPlanCode: string;
  targetPlanCode: string;
  amountToPaySek: number;
  vatAmountSek: number;
  netAmountSek: number;
  paymentProvider: string;
  providerRef: string | null;
  status: string;
  createdAt: string;
}

export const billingApi = {
  getCurrentPlan: () => api.get<CurrentPlan>('/billing/plan/current'),
  getPlanList: () => api.get<{ plans: PlanListItem[] }>('/billing/plan/list'),
  quoteUpgrade: (targetPlanCode: 'A' | 'B' | 'C') =>
    api.post<UpgradeQuote>('/billing/quote-upgrade', { targetPlanCode }),
  getPendingPurchase: () => api.get<{ pendingPurchase: PendingPurchase | null }>('/billing/purchase/pending'),
  initPurchase: (targetPlanCode: 'A' | 'B' | 'C') =>
    api.post<{
      purchaseId: number;
      receiptId: number;
      status: string;
      paymentInstructions: {
        provider: string;
        providerRef: string;
        amountSek: number;
        message: string;
      };
    }>('/billing/purchase/init', { targetPlanCode }),
  cancelPendingPurchase: (id: number) => api.delete<{ ok: boolean }>(`/billing/purchase?id=${id}`),
  listReceipts: () => api.get<{ receipts: BillingReceipt[] }>('/billing/receipts/list'),
  getReceipt: (id: number) => api.get<BillingReceiptDetail>(`/billing/receipt?id=${id}`),
};
